export function tripPhase(row) {
  const trip = row.trip || row;
  const batch = trip.batches?.find((item) => item.id === row.participant?.batch_id);
  const state = batch?.execution_state || trip.state;
  if (["cancelled", "removed"].includes(row.participant?.status) || ["cancelled", "archived"].includes(trip.state)) return "past";
  if (["completed", "cancelled"].includes(state)) return "past";
  if (["active", "in_progress"].includes(state)) return "active";
  return "upcoming";
}

export function travellerImage(item) {
  const trip = item?.trip || item || {};
  const cover = item?.cover_image || trip.cover_image;
  const url = typeof cover === "string" ? cover : cover?.url || cover?.download_url || cover?.thumbnail_url || cover?.media?.url;
  const explicit = url || trip.cover_image_url || trip.hero_image_url;
  if (explicit) return explicit;
  const place = `${trip.destination || ""} ${trip.region || ""} ${trip.title || ""}`.toLowerCase();
  if (/island|maldives|beach|coast|goa|thailand/.test(place)) return "/assets/I am a traveller.jpeg";
  if (/forest|meghalaya|woodland/.test(place)) return "/assets/traveller-forest.jpg";
  return "/assets/traveller-mountains.jpg";
}

export function tripStart(row) {
  const trip = row.trip || row;
  const batch = trip.batches?.find((item) => item.id === row.participant?.batch_id);
  return batch?.start_date || row.participant?.batch?.start_date || trip.start_date || "";
}

export function firstName(user, profile) {
  return (profile?.display_name || user?.full_name || "traveller").trim().split(/\s+/)[0];
}
